/* eslint-disable camelcase */
import { Button, Grid, Row } from '@rocketmakers/armstrong';
import * as React from 'react';

import { BackButton } from '../../components/buttons/back-button';
import { useBeeConfig } from '../../hooks/beeConfig';
import { useRoutePaths } from '../../../../shared/context/paths';
import { routePaths } from '../../routes';
import { DialDescriptor } from './dial-descriptor';
import { DeviceType, RoomDialWrf06, RuleActionType } from '../../../../shared/api-clients/_api';
import { DeviceSummary } from '../../components/layout/deviceSummary/device-summary';
import { getDeviceName } from '../assign-heating-zones/utils';
import { useZones } from '../../hooks/zones';

import './add-dial.scss';
import { Spinner } from '../../components/spinner/spinner';

export const AddDialView: React.FunctionComponent = () => {
  const { devices, getDevicesByType, loading } = useBeeConfig();
  const { push } = useRoutePaths();
  const { getZoneDescription } = useZones();

  const tempDials = React.useMemo(
    () =>
      getDevicesByType<RoomDialWrf06>([DeviceType.WRF06]).filter(
        ({ params: { action_type } }) => action_type === RuleActionType.CONTROL
      ),
    [devices]
  );

  const handleNext = async () => {
    push(routePaths.thermostat.thermostatModel);
  };

  const handleAdd = () => {
    push(routePaths.thermostat.configureDial);
  };

  const hasDials = tempDials.length > 0;

  return (
    <div>
      {loading && <Spinner />}
      <BackButton />
      <h1>
        Configuration <span className="color-primary">Dial</span>
      </h1>
      <DialDescriptor />
      <Grid className="grid">
        <Row>
          {tempDials?.map(device => (
            <DeviceSummary
              key={device.params.install_location}
              name={getZoneDescription(device.params.install_location)}
              fields={[
                { name: 'Type:', value: getDeviceName(device) },
                { name: 'MODBUS:', value: device.params.address },
                { name: 'Channel:', value: device.params.channel },
              ]}
              onSelect={() => {
                push(routePaths.thermostat.editDial, { installLocation: device.params.install_location }, device);
              }}
              data-qa={`heating-dial-${device.params.install_location}-summary`}
            />
          ))}
        </Row>
      </Grid>
      <Button className="btn-full" onClick={handleAdd} data-qa="add-button">
        Add {hasDials ? 'another' : 'a'} temperature dial
      </Button>
      <Row className="btn-row">
        <Button className="continue-button btn-full btn-large" onClick={handleNext} data-qa="continue-button">
          Next
        </Button>
      </Row>
    </div>
  );
};
